module.exports = __webpack_public_path__ + "fonts/Red_Hat_Text-300-latin2.db81921.woff2";